module.exports = __webpack_public_path__ + "static/snap-mobile-0e117a121602ba43a6c2e5c7b5ccee1a.png";